module.exports = __webpack_public_path__ + "static/media/Tony Stark 3.4da44483.jpg";